import script from "./FAQPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQPage.vue?vue&type=script&setup=true&lang=js"

import "./FAQPage.vue?vue&type=style&index=0&id=6ba437b1&lang=css"

const __exports__ = script;

export default __exports__